module.exports = __webpack_public_path__ + "static/img/banner-fabric-1.c844a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-1.jpg
// module id = 511
// module chunks = 63